import MedicalContent from "./MedicalContent";

export default MedicalContent;